import type { TableColumn } from "@components";
import type { PaginatedChecklistTemplateItem } from "../types";

export const FORMS_LIST_COLUMNS: TableColumn<PaginatedChecklistTemplateItem>[] =
	[
		{
			id: "name",
			label: "Nome do formulário",
			minWidth: 280,
		},
		{
			id: "templateAnsweredCount",
			label: "Vezes respondido",
			minWidth: 140,
		},
		{
			id: "updatedAt",
			label: "Última atualização",
			minWidth: 160,
		},
		{
			id: "actions",
			label: "Ações",
			minWidth: 150,
		},
	];
